import { DefaultSchedule, DefaultScheduleFrequency } from "../../components/SubscriptionsSettings/SubscriptionsSettingsSchedule";
import { SchedulerFrequency, SubscriptionItem, SubscriptionItemPayload, SubscriptionItemType, SubscriptionSchedule } from "../../types";
import { BulkExportPayloadDTO, SavedBulkExportPayloadDTO, SlidePayloadDTO, SubscriptionItemDTO } from "../types";

export function subscriptionItemFromDTO(item: SubscriptionItemDTO): SubscriptionItem {
  const subscriptionItem: SubscriptionItem = {
    id: item.id,
    date: item.lastModified,
    type: item.subscriptionType,
    name: item.name,
    fileFormat: item.fileFormat,
    schedule: scheduleFromDTO(item),
    payload: JSON.parse(item.payload),
  };
  subscriptionItem.payload = payloadFromDTO(item);

  return subscriptionItem;
}

function payloadFromDTO(item: SubscriptionItemDTO): SubscriptionItemPayload {
  if (item.subscriptionType === SubscriptionItemType.Slide) {
    const slidePayloadDTO = JSON.parse(item.payload) as SlidePayloadDTO;
    return slidePayloadDTO[0];
  }
  if (item.subscriptionType === SubscriptionItemType.BulkExport) {
    const bulkExportPayloadDTO = JSON.parse(item.payload) as BulkExportPayloadDTO;
    return bulkExportPayloadDTO;
  }
  if (item.subscriptionType === SubscriptionItemType.SavedBulkExport) {
    const savedBulkExportPayloadDTO = JSON.parse(item.payload) as SavedBulkExportPayloadDTO;
    return savedBulkExportPayloadDTO;
  }

  return JSON.parse(item.payload);
}

function scheduleFromDTO(item: SubscriptionItemDTO): SubscriptionSchedule {
  const time: string | undefined = item.time ? getZonelessTimeFromDate(item.time) : undefined;

  switch (item.schedulerFrequency) {
    case SchedulerFrequency.Dayly:
      const dailyDefaultSchedule = DefaultScheduleFrequency[SchedulerFrequency.Dayly];
      return {
        ...dailyDefaultSchedule,
        time: time || dailyDefaultSchedule.time,
      };
    case SchedulerFrequency.Weekly:
      const weeklyDefaultSchedule = DefaultScheduleFrequency[SchedulerFrequency.Weekly];
      return {
        ...weeklyDefaultSchedule,
        day: item.day || weeklyDefaultSchedule.day,
        time: time || weeklyDefaultSchedule.time,
      };
    case SchedulerFrequency.Monthly:
      const monthlyDefaultSchedule = DefaultScheduleFrequency[SchedulerFrequency.Monthly];
      return {
        ...monthlyDefaultSchedule,
        day: item.day || monthlyDefaultSchedule.day,
        time: time || monthlyDefaultSchedule.time,
      };
    case SchedulerFrequency.Quarterly:
      const quarterlyDefaultSchedule = DefaultScheduleFrequency[SchedulerFrequency.Quarterly];
      return {
        ...quarterlyDefaultSchedule,
        month: item.month || quarterlyDefaultSchedule.month,
        day: item.day || quarterlyDefaultSchedule.day,
        time: time || quarterlyDefaultSchedule.time,
      };
    case SchedulerFrequency.SemiAnnuality:
      const semiAnnualityDefaultSchedule = DefaultScheduleFrequency[SchedulerFrequency.SemiAnnuality];
      return {
        ...semiAnnualityDefaultSchedule,
        month: item.month || semiAnnualityDefaultSchedule.month,
        day: item.day || semiAnnualityDefaultSchedule.day,
        time: time || semiAnnualityDefaultSchedule.time,
      };
    case SchedulerFrequency.Annuality:
      const annualityDefaultSchedule = DefaultScheduleFrequency[SchedulerFrequency.Annuality];
      return {
        ...annualityDefaultSchedule,
        month: item.month || annualityDefaultSchedule.month,
        day: item.day || annualityDefaultSchedule.day,
        time: time || annualityDefaultSchedule.time,
      };
    default:
      return DefaultSchedule;
  }
}

/**
 * Extracts time and transforms it to GMT+2
 * @param dateTime 0001-01-02T00:32:00+04:00:00
 * @returns 22:32:00
 */
function getZonelessTimeFromDate(dateTime: string): string {
  const targetTimezone = 2;

  const [, time, zoneTime] = dateTime.split(/\+|T/);
  const [timeHours, timeMinutes, timeSeconds] = time.split(":").map(Number);
  const [zoneTimeHours] = zoneTime.split(":").map(Number);

  const timezoneDiff = zoneTimeHours - targetTimezone;

  const zonelessHours = (24 + timeHours - timezoneDiff) % 24;

  return [zonelessHours, timeMinutes, timeSeconds].map((t) => ("0" + t).slice(-2)).join(":");
}
